import cx from 'classnames'
import Image from 'next/image'
import React from 'react'

import fas from '@/assets/images/teaser/common/FAS.svg'
import VerticalSlideAnimation from '@/components/Common/Animation/VerticalSlideAnimation'

export default function TextView({ eyecatch }: { eyecatch: string }) {
  return (
    <div
      className={cx(
        'w-full',
        'h-full',
        'backdrop-blur-2xl',
        'backdrop-brightness-75',
        'absolute',
        'z-30',
        'left-0',
        'top-0',
        'text-white',
        'text-center',
        'flex',
        'flex-col'
      )}
    >
      {/*/!* chromeでblurの上でアニメーションをかけると1回消えるバグがあるのでダミーのアニメーションを実行 *!/*/}
      <div className={cx(['flex-none', 'opacity-[0.01]', 'animate-[zoom-in_.1s]'])}>.</div>
      <div className={cx('flex-auto', 'flex', 'items-center', 'justify-center', ...['sm:pt-[100px]'])}>
        <div>
          <div
            className={cx(
              'flex-1',
              'font-goldenbook',
              'mx-auto',
              'items-center',
              'w-[103px]',
              'mb-[26px]',
              ...['sm:w-[141px]', 'sm:mb-[46px]']
            )}
          >
            <VerticalSlideAnimation additionalClassNames={['w-full']}>
              <Image src={fas.src} width={fas.width} height={fas.height} alt={'FAS'} className="w-full" />
            </VerticalSlideAnimation>
          </div>
          <div className={cx('flex-1', 'mb-[22px]', ...['sm:mb-[25px]'])}>
            <VerticalSlideAnimation>
              <div
                className={cx(
                  'text-[18px]',
                  'tracking-[1.8px]',
                  'mb-[10px]',
                  'font-yu-mincho',
                  ...['sm:text-[22px]', 'sm:tracking-[2.2px]']
                )}
              >
                発酵科学スキンケア
              </div>
            </VerticalSlideAnimation>
            <div
              className={cx(
                'font-neue-haas-grotesk',
                'text-[12px]',
                'tracking-[.48px]',
                ...['sm:text-[13px]', 'sm:tracking-[.52px]']
              )}
            >
              <VerticalSlideAnimation>Fermentation & Science</VerticalSlideAnimation>
            </div>
          </div>
          <div
            className={cx(
              'flex-1',
              'text-[13px]',
              'mb-[22px]',
              'leading-[27px]',
              'tracking-[1.3px]',
              'font-yu-mincho',
              ...['sm:text-[14px]', 'sm:mb-[35px]', 'sm:leading-[30px]', 'sm:tracking-[1.4px]']
            )}
          >
            <VerticalSlideAnimation>
              日本古来から伝わる発酵を、
              <br />
              最先端の科学で効果を引き出す、
              <br />
              発酵科学スキンケアブランド誕生。
            </VerticalSlideAnimation>
          </div>
          <div
            className={cx(
              'flex-1',
              'font-yu-mincho',
              'text-[24px]',
              'tracking-[.48px]',
              'mb-[12px]',
              ...['sm:text-[28px]', 'sm:mb-[18px]', 'sm:tracking-[.56px]']
            )}
          >
            {eyecatch.split('\n').map((text, index) => {
              return <VerticalSlideAnimation key={index}>{text}</VerticalSlideAnimation>
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
